import React, { useEffect, useState } from 'react'
import { Button, Form, Row, Col } from 'react-bootstrap'
import { Nav } from 'react-bootstrap';
import { withRouter, Link } from 'react-router-dom';
import MenuButton from './MenuButton';

const TransactionMenu = () => {
    return (
        <div className="tablet-center">
            <h1>Postfach</h1>
            <div className="flex-linebreak"></div>
            <div className="main-menu text-center ">
                <Row className="main-menu-row">
                    <Nav.Item className="">
                        <Nav.Link as={Link} className="text-dark main-menu-navitem main-menu-btn" to="/incoming-transactions">Posteingang</Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="">
                        <Nav.Link as={Link} className="text-dark main-menu-navitem main-menu-btn" to="/outgoing-transactions">Postausgang</Nav.Link>
                    </Nav.Item>
                </Row>
            </div>
            
        </div>
    )
}

export default TransactionMenu